import { Component, OnInit } from '@angular/core'
import { collection, collectionData, deleteDoc, doc, orderBy, query, serverTimestamp, updateDoc } from '@angular/fire/firestore'
import * as firestore from 'firebase/firestore'
import { Faq, FaqCategory, faqsPath } from '@parkupp/core'
import Swal from 'sweetalert2'
import { AdminService } from '../../../../services/admin.service'

@Component({
    selector: 'app-admin-faq-list',
    templateUrl: './admin-faq-list.component.html',
    styleUrls: ['./admin-faq-list.component.scss'],
})
export class AdminFaqListComponent implements OnInit {
    clientFaqs: Faq[] = []
    merchantFaqs: Faq[] = []
    loading = true

    constructor(private adminService: AdminService) {
        const ref = query(collection(this.adminService.firestore, faqsPath()), orderBy('category'), orderBy('order'))
        collectionData(ref, { idField: '$key' }).subscribe((documents: any[]) => {
            this.clientFaqs = []
            this.merchantFaqs = []
            documents.forEach((data) => {
                const faq = new Faq(data)
                faq.$key = data.$key
                if (faq.category === 'merchant') {
                    this.merchantFaqs.push(faq)
                } else {
                    this.clientFaqs.push(faq)
                }
            })
            this.loading = false
        })
    }

    ngOnInit(): void {}

    async togglePublished(faq: Faq) {
        if (!faq.$key) return
        const reference = doc(this.adminService.firestore, faqsPath(), faq.$key)
        await updateDoc(reference, {
            published: !faq.published,
            updatedAt: serverTimestamp() as firestore.Timestamp,
        })
    }

    async moveUp(faq: Faq, list: Faq[]) {
        const index = list.findIndex((f) => f.$key === faq.$key)
        if (index <= 0) return
        await this.swapOrder(list[index], list[index - 1])
    }

    async moveDown(faq: Faq, list: Faq[]) {
        const index = list.findIndex((f) => f.$key === faq.$key)
        if (index < 0 || index >= list.length - 1) return
        await this.swapOrder(list[index], list[index + 1])
    }

    private async swapOrder(a: Faq, b: Faq) {
        if (!a.$key || !b.$key) return
        const aOrder = a.order ?? 0
        const bOrder = b.order ?? 0
        await Promise.all([
            updateDoc(doc(this.adminService.firestore, faqsPath(), a.$key), {
                order: bOrder,
                updatedAt: serverTimestamp() as firestore.Timestamp,
            }),
            updateDoc(doc(this.adminService.firestore, faqsPath(), b.$key), {
                order: aOrder,
                updatedAt: serverTimestamp() as firestore.Timestamp,
            }),
        ])
    }

    async deleteFaq(faq: Faq) {
        if (!faq.$key) return
        const result = await Swal.fire({
            title: 'Delete FAQ?',
            text: `"${faq.question}" will be permanently removed. This cannot be undone.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#d33',
        })
        if (!result.isConfirmed) return
        const reference = doc(this.adminService.firestore, faqsPath(), faq.$key)
        await deleteDoc(reference)
    }

    trackByKey(_index: number, faq: Faq) {
        return faq.$key
    }
}
